import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider as UrqlProvider } from 'urql';
import { gqlClient } from './lib/gql.js';
import App from './App.js';
import { useAuthStore, setQueryClient } from './stores/auth-store.js';
import { ConfirmProvider } from './components/ConfirmDialog.js';
import { PosRealtimeProvider } from './components/PosRealtimeProvider.js';
import { loadBranding } from './lib/branding-loader.js';
import { initTheme } from './stores/theme.store.js';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
});
// S0-7 hardening: inject queryClient into auth-store so setActiveEnv() can
// invalidate the React Query cache when flipping test↔live.
setQueryClient(queryClient);

// Boot: apply the persisted light/dark theme to <html> before first paint,
// then restore session + pull per-tenant branding. All best-effort; the app
// renders regardless (RequireAuth bounces unauthenticated users to /login).
initTheme();
void useAuthStore.getState().hydrate();
void loadBranding();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <UrqlProvider value={gqlClient}>
        <BrowserRouter basename={import.meta.env.BASE_URL}>
          <ConfirmProvider>
            <PosRealtimeProvider>
              <App />
            </PosRealtimeProvider>
          </ConfirmProvider>
        </BrowserRouter>
      </UrqlProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
